import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { ReportTypeUrl } from '@/entities/Report'

/**
 * Функция обновления данных таблиц
 */
export const useResendMeterData = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      const cabinet_id = route.params.object_id
      return http.post(`/cabinets/${cabinet_id}/monitoring/meters-update`, data)
    },
  })

  const send = async (order_number: number, type: string) => {
    try {
      await mutation.mutateAsync({ order_number, type })

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}

/**
 * Функция отправки запроса на формирование файла отчета
 */
export const useSendReportFile = () => {
  const http = useHttp()

  const { addError, addSuccess, addWarning } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      const cabinet_id = route.params.object_id
      const searchParams = new URLSearchParams(data)
      const type = ReportTypeUrl[route.params.report_type as string]

      return http.post(`/reports/cabinet/${cabinet_id}/${type}?${searchParams}`, null)
    },
  })

  const send = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      if (data.download) {
        addSuccess(trs('itf.report_file_download'))
      } else if (data.send) {
        addSuccess(trs('itf.report_file_send'))
      }
    } catch (error: any) {
      const notify = error.status === 404 ? addWarning : addError

      notify(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}
